import { render, staticRenderFns } from "./specialPerson.vue?vue&type=template&id=5be6d94a&scoped=true&"
import script from "./specialPerson.vue?vue&type=script&lang=js&"
export * from "./specialPerson.vue?vue&type=script&lang=js&"
import style0 from "./specialPerson.vue?vue&type=style&index=0&id=5be6d94a&scoped=true&lang=css&"
import style1 from "./specialPerson.vue?vue&type=style&index=1&id=5be6d94a&scoped=true&lang=css&"
import style2 from "./specialPerson.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be6d94a",
  null
  
)

export default component.exports